import { Link, useParams } from "react-router-dom";
import Seo from "@/components/site/Seo";
import Directory from "@/components/site/Directory";
import CategoryCard from "@/components/site/CategoryCard";
import { PageHeader, Loading, Empty } from "@/components/site/Ui";
import { useApi } from "@/lib/api";
import { useSite } from "@/lib/site";

export function SoftwarePage() {
  return (
    <>
      <Seo title="Software Directory" description="Search and filter business software by category, pricing model and use case. Compare tools side by side." />
      <PageHeader eyebrow="Software directory" title="Explore business software" testId="software-page-header">
        Search by name or keyword, filter by category, pricing model and business use case, then add tools to compare.
      </PageHeader>
      <div className="container-x py-12"><Directory /></div>
    </>
  );
}

export function CategoriesPage() {
  const { categories, loaded } = useSite();
  return (
    <>
      <Seo title="Software Categories" description="Browse business software categories: accounting, CRM, HR, marketing, AI, support, communications, project management, e-commerce and cybersecurity." />
      <PageHeader eyebrow="Categories" title="Software categories" testId="categories-page-header">Explore tools grouped by the business problem they solve.</PageHeader>
      <div className="container-x py-12">
        {!loaded ? <Loading /> : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {categories.map((c, i) => <CategoryCard key={c.slug} c={c} i={i} detailed testId={`categories-card-${c.slug}`} />)}
          </div>
        )}
      </div>
    </>
  );
}

export function CategoryPage() {
  const { slug } = useParams();
  const { data, loading, error } = useApi(`/categories/${slug}`);
  if (loading) return <Loading />;
  if (error) return <div className="container-x py-20"><Empty title="Category not found"><Link to="/categories" className="text-[#3F5E7A] underline">Browse all categories</Link></Empty></div>;
  return (
    <>
      <Seo title={data.seo_title || `${data.name} Software`} description={data.seo_description || data.description}
        jsonLd={{ "@context": "https://schema.org", "@type": "CollectionPage", name: `${data.name} Software`, description: data.description }} />
      <PageHeader eyebrow={<Link to="/categories" className="hover:underline">Categories</Link>} title={`${data.name} software`} testId="category-page-header">{data.description}</PageHeader>
      <div className="container-x py-12"><Directory key={slug} fixedCategory={slug} /></div>
    </>
  );
}
